import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { UserActivityCategory, UserActivityTypes } from '@pascal/iframe-service';

import { useStore, useTranslation } from '../../../../../hooks';
import { setTranslationValues } from '../../../../../helpers';
import { SidebarTimer } from '../timer';
import { SidebarCard } from '../card';
import { T } from '../../../../../constants';

interface SidebarPGWheelProps {
  onClose?: () => void;
}

export const SidebarPGWheel: React.FC<SidebarPGWheelProps> = observer(({ onClose }) => {
  const { boostedJackpotStore, userActivityStore } = useStore();
  const { wheelInfo } = boostedJackpotStore;
  const t = useTranslation();

  const handleDetailsClick = useCallback(() => {
    userActivityStore.sendTrackUserActivity({
      category: UserActivityCategory.PromoTools,
      type: UserActivityTypes.BoostedJackpotSideBarMenuCard
    });
    boostedJackpotStore.setIsBoostedJackpotInfoPopup(true);
    onClose?.();
  }, [onClose]);

  if (!wheelInfo) return null;

  return (
    <SidebarCard
      className="wheel"
      title={t(T.PG_WHEEL)}
      amount={wheelInfo.poolAmount}
      winnersLabel={t(T.WINNING_COUNT)}
      onDetailsClick={handleDetailsClick}
      currencyCode={wheelInfo.currencyCode}
      winnersValue={setTranslationValues(t(T.PG_WHEEL_WIN_COUNT_UP_TO), { count: wheelInfo.totalWinCount })}
    >
      <SidebarTimer endDate={wheelInfo.endDate} />
    </SidebarCard>
  );
});
